import { setPicSize as SetPicSize } from "mpfe-utils"
/**
 * @description 裁剪图片
 * @param {*} picUrl 图片源地址
 * @param {*} picWidth 裁剪目标宽度
 * @param {*} picHeight 裁剪目标高度
 * @param {*} quality 图片质量，最高100
 * @returns {string} 裁剪后的图片地址
 */
export const setPicSize = SetPicSize

// 裁剪文章页左侧图片
export const cutUserAvatar = function() {
    let userAvatar = document.querySelector('.user-pic img')
    if(userAvatar) {
        let srcUrl = userAvatar.getAttribute('data-src')
        srcUrl && userAvatar.setAttribute('data-src', setPicSize(srcUrl, 140,140, 'q_70,c_lfill'))
    }
}